var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['scroll-to-anker'],attrs:{"href":`#${_vm.ankerId}`},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.scrollToAnker.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }